import MapMixin from './mixin';
import { MglPopup, MglMarker, MglNavigationControl, MglGeolocateControl } from '@advisr/v-mapbox';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinMapPublic',
  components: {
    MglPopup,
    MglMarker,
    MglNavigationControl,
    MglGeolocateControl
  },
  mixins: [MapMixin],
  props: {
    detailsBaseLink: {
      type: String,
      required: false,
      default: 'digitaltwin-mgmt'
    }
  },
  data() {
    return {
      popupCoordinates: [0, 0],
      popupShown: false,
      mapLoaded: false,
      markerStyle: 'default'
    };
  },
  computed: {
    markerPopupOffset() {
      return this.markerStyle === 'outlined' ? [80, 0] : [10, 0];
    },
    markerWidthClass() {
      return `pmMglMarkerWidth${this.markerStyle === 'outlined' ? 'Outlined' : ''}`;
    },
    markerHeadClasses() {
      return ['pmMglMarkerBase', `pmMglMarker${this.markerStyle === 'outlined' ? 'Outlined' : ''}`, this.markerWidthClass].join(' ');
    },
    markerImageClass() {
      return `pmMglMarkerImage${this.markerStyle === 'outlined' ? 'Outlined' : ''}`;
    },
    markerLineClass() {
      return `pmMglMarkerLine ${this.markerStyle === 'outlined' ? 'pmMglMarkerLineOutlined' : ''}`.trim();
    },
    markerAnchorClass() {
      return `pmMglMarkerBase pmMglMarkerAnchor ${this.markerStyle === 'outlined' ? 'pmMglMarkerAnchorOutlined' : ''}`.trim();
    },
    markerHeadStyle() {
      return this.markerStyle === 'outlined' ? `border-color: ${this.markerColor}` : `background-color: ${this.markerColor}`;
    },
    markerHeadIconColor() {
      return this.markerStyle === 'outlined' ? this.color : 'white';
    },
    markerLineStyle() {
      return this.markerStyle === 'outlined' ? `border-color: ${this.markerColor}` : undefined;
    },
    markerAnchorStyle() {
      return this.markerStyle === 'outlined' ? `background-color: ${this.markerColor}` : undefined;
    }
  },
  watch: {
    $route() {
      this.getMarkerStyle();
    }
  },
  created() {
    this.zoomToTwins = false;
    this.scrollByPolygonOnZoom = false;
    this.displayTwinPolygons = false;
    this.resetMapOnBoundsChange = true;
    this.defaultPitch = 50;
    this.getMarkerStyle();
    this.scrollByPolygonOnZoom = false;
  },
  methods: {
    getMarkerStyle() {
      const markerStyle = (get(this.$route, 'query.markerstyle') || 'default').toLowerCase();
      switch (markerStyle) {
        case 'outlined':
          this.markerStyle = 'outlined';
          break;
        default:
          this.markerStyle = 'default';
          break;
      }
    },
    editDtwin(id) {
      this.$router.push({
        path: `/${this.detailsBaseLink}/${id}`
      });
    },
    openPopup(a) {
      this.markerItemClicked({
        component: a.component.$options.parent
      });
    },
    selectMarker(e) {
      this.unSelectMarker();
      e.marker._element.classList.add('selected-marker');
    },
    unSelectMarker() {
      let MglMarkers = document.querySelector('.mapboxgl-canvas-container').childNodes;
      MglMarkers.forEach(item => {
        if (item.classList.contains('selected-marker')) {
          item.classList.remove('selected-marker');
        }
      });
    }
  }
};